import { render, staticRenderFns } from "./BuildingSvg.vue?vue&type=template&id=231fd8bc&"
import script from "./BuildingSvg.vue?vue&type=script&lang=js&"
export * from "./BuildingSvg.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports